<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3ns01a/images/9781455571550_cover_epub.jpg?1733151142387" alt="This image is the cover for the book Promise to Defend, Rescue Ops"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Promise to Defend, Rescue Ops
      </h1>
      <p class="bookDescription body article font2">
        <p>"No one does Romantic Suspense like Diana Gardin. I was rooting for Ronin and Olive from the very first page." -- Susan Stoker, <i>New York Times</i> bestselling author <br/>A sexy and suspenseful standalone in the Rescue Ops series.<br/> By saving her, he might just save himself...<br/>I'm broken. I have been for seven years. Ever since my wife was murdered while I was deployed overseas. I was protecting our country, but I should have been protecting her. I haven't looked at another woman since--but then Olive Alexander crossed my path. She stirs up feelings I thought were long dead. So when her house is ransacked after she receives a threatening message, I know I have to step in and keep her safe. I failed my wife, but I won't fail Olive. Unfortunately, Olive isn't exactly ready to accept my help...<br/><br/> With her sexy-as-sin pencil skirts and sleek ponytails, Olive clearly doesn't let anything--or <i>anyone--</i>mess up her perfectly ordered life. But years spent working as a special ops soldier has taught me how to read people... and I know Olive is hiding something. When my covert mission for Night Eagle Security collides with Olive's past, I'll have to get her to open up--or risk losing her. And losing Olive is <i>not</i> an option. If she's in danger, I'll defend her...even if it costs me my life.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Gardin
      </h2>
      
      <p class="authorDescription body article"><B>Diana Gardin</B> is a wife of one and a mom of two. Writing is her second full time job to that, and she loves it! Diana writes contemporary romance in the Young Adult and New Adult categories. She's also a former Elementary school teacher. She loves steak, sugar cookies, and Coke, and hates working out.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b99895c2